import sanitizeHtml from "sanitize-html";

export const stringUtil = {
  toBase64: (str) => {
    return btoa(String.fromCharCode(...new TextEncoder().encode(str)));
  },

  fromBase64: (base64) => {
    return new TextDecoder().decode(
      Uint8Array.from(atob(base64), (c) => c.charCodeAt(0)),
    );
  },

  prepareDangerousHTML: (html) => {
    if (typeof html !== "string" || html.trim() === "") return "";

    return sanitizeHtml(html, {
      disallowedTagsMode: "discard",
      allowedTags: [
        "strong",
        "em",
        "s",
        "sub",
        "sup",
        "a",
        "p",
        "ul",
        "ol",
        "li",
      ],
      allowedAttributes: {
        a: ["href", "target", "rel"],
      },
      allowedSchemesByTag: {
        a: ["https"],
      },
    });
  },
};
